import { render, staticRenderFns } from "./RelatorioSalesOrderTableView.vue?vue&type=template&id=089f6cee"
import script from "./RelatorioSalesOrderTableView.vue?vue&type=script&lang=js"
export * from "./RelatorioSalesOrderTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports